import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { TabService } from '../../../../tabconfig/tab.service';
import { DialogService } from '../../../../common/dialog.service';
import { StudentsService } from '../../../../api/Services/maintenance/students.service';
import { StudentsAddComponent } from '../students-add/students-add.component';
import { Tab } from 'src/app/tabconfig/tab.model';
import { AuthService } from '../../../../system/auth.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AssignStudentCourseComponent } from '../../assign-student-course/assign-student-course.component';
//import {MatDialog, MatDialogConfig} from "@angular/material";
import { Router } from '@angular/router';

@Component({
  selector: 'app-students-list',
  templateUrl: './students-list.component.html',
  styleUrls: ['./students-list.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})



export class StudentsListComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  @Input() data;
  public displayedColumns: string[] = ['per_vc_document_number', 'per_vc_full_names', 'stu_vc_status', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

 
  parameters: any[];


  public form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private studentsServices: StudentsService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private tabService: TabService,
    private authService: AuthService,
    private dialog: MatDialog,
    private router: Router
  ) {
  }


  ngOnInit(): void {
    // console.log("OK");
    // this.listar();
    this.initForm();
    this.loadInitial();
  }

  public initForm() {
    this.form = this.formBuilder.group({
      pi_per_in_document_type: 0,
      pi_per_vc_document_number: '',
      pi_stu_in_status: 0
    });
  }

  public loadInitial() {
    this.parameters = this.authService.getParameters();
  }

  public listar() {

     
    console.log(this.form.getRawValue());
    this.studentsServices.GetAll(this.form.getRawValue().pi_per_in_document_type, this.form.getRawValue().pi_per_vc_document_number, this.form.getRawValue().pi_stu_in_status).subscribe(
      data => {
        console.log(data)
       
        if (data['sucess']) {
          let result = data['data'];
          this.dataSource = new MatTableDataSource<any[]>(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );

  }


  public nuevo() {
    this.tabService.addTab(new Tab(StudentsAddComponent, "Nuevo Alumno", { parent: 'ListadoComponent' }));
  }

  public buscar() {
    debugger;
    this.listar();
  }

  public editar(element) {
    this.tabService.removeTab(this.data.id - 1)
    this.tabService.addTab(new Tab(StudentsAddComponent, "Modificación Alumno", { parent: 'ListadoComponent', element: element }));
  }

  public eliminar(id) {
    this.dialogService.openConfirmDialog('Seguro de eliminar al alumno?')
      .afterClosed().subscribe(res => {
        if (res) {
           
          this.studentsServices.Delete(id).subscribe(
            data => {
               
              this.listar();
              this.toastr.success('Se eliminó la correctamente.', 'Correcto');
            }
          );
        }
      });
  }

  public activar(element){
    this.dialogService.openConfirmDialog('Seguro que desea activar al alumno?')
      .afterClosed().subscribe(res => {
        if (res) {
          
          element.stu_in_status = 1;
          this.studentsServices.Update_Status(element).subscribe(
            data => {
              console.log(data);
              
              this.listar();
              this.toastr.success('Se activo la correctamente.', 'Correcto');
            }
          );
        }
      });
  }
  public asignar(element){
    this.tabService.removeTab(this.data.id - 1)
    this.tabService.addTab(new Tab(AssignStudentCourseComponent, "Asignación del curso", { parent: 'ListadoComponent', element: element }));
  }

   

}


